import React, {Component, PropTypes} from 'react'

class WatchesAndWarnings extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;

  }


  render() { // REQUIRED
    return (
      <div className='gnm-watches-and-warnings'>
        {this.affiliate === 'kotv'
          ? <iframe src="https://content.wdtinc.com/imap/imap5/?MAPID=12241&CLIENTID=20212"
          frameBorder="0" marginHeight="0" marginWidth="0" width="100%" height="600" scrolling="no" align="left" allowFullScreen="true" />
        : <iframe src="https://content.wdtinc.com/imap/imap5/?MAPID=12240&CLIENTID=20211"
          frameBorder="0" marginHeight="0" marginWidth="0" width="100%" height="600" scrolling="no" align="left"  allowFullScreen="true" />
        }
      </div>
    )
  }
}

export default WatchesAndWarnings



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WatchesAndWarnings/index.js